import { Component, h, Host, Prop } from '@stencil/core';

import store from '@/store';

export interface FdsLoaderSizeValue {
  height: number | string;
  width: number | string;
}
export type FdsLoaderSize = Record<string, number | string>;

export type FdsLoaderSizeKey = keyof FdsLoaderSize;

const LOADER_SIZE: FdsLoaderSize = {
  xs: '1.125rem',
  sm: '1.5rem',
  md: '1.875rem',
  lg: '3rem',
};

/**
 * @part spinner - The spinner element of the loader with the color and size
 */
@Component({
  tag: 'fds-loader',
  styleUrl: 'styles/loader.scss',
  shadow: true,
})
export class Loader {
  /**
   * The size of the loader
   */
  @Prop() size: FdsLoaderSizeKey = 'xs';

  /**
   * The color of the loader
   */
  @Prop() color: string;

  private getStyle() {
    let style = {};
    const size = LOADER_SIZE[this.size];

    style = {
      ...style,
      height: size,
      width: size,
    };

    if (this.color) {
      style = {
        ...style,
        color: this.color,
      };
    }

    return style;
  }

  render() {
    const customStyle = this.getStyle();

    return (
      <Host class={`${store.mode}`} role="status" aria-label="loading indicator">
        <div class="fds-loader__spinner" part="spinner" style={customStyle}></div>
      </Host>
    );
  }
}
